function changePasswordDialog () {
  return {
    restrict: 'E',
    templateUrl: '/core/dialogs/change-password/change-password-dialog.html?$$REVISION$$'
  }
}

export { changePasswordDialog }
